exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete_button[data-v-db323b32]:focus,.delete_button[data-v-db323b32]:active{border-color:#ed6e6e !important}\n", ""]);

// exports
